import LatestWork from './LatestWork';
import Contant from './Contact';
import Header from './header';
import Skills from "./skills";
import PrimaryMessage from './PrimaryMessage';
import {useRef} from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const Landing = (props)=> {

    const landing = useRef();
    const skills = useRef();
    const latest = useRef();
    const contact = useRef();
    
    const scrollToTop = () =>{ 
        landing.current.scrollIntoView({behavior: 'smooth'});
    }

    return(
        <div className='landing' ref={landing}>

            <Header skillsRef={skills} latestRef={latest} contactRef={contact}/>

            <PrimaryMessage />

           
            <Skills skillsRef={skills} />
                <FontAwesomeIcon onClick={scrollToTop} className='goUpIcon' icon='angle-double-up'  size='2x'>
                </FontAwesomeIcon>
           

            <LatestWork latestRef={latest}  />
            
            <Contant contactRef={contact} />

         
       

        </div>
    );
} 

export default Landing;